import { EventApi } from '@fullcalendar/core';
var ResourceApi = /** @class */ (function () {
    function ResourceApi(calendar, rawResource) {
        this._calendar = calendar;
        this._resource = rawResource;
    }
    ResourceApi.prototype.setProp = function (name, value) {
        this._calendar.dispatch({
            type: 'SET_RESOURCE_PROP',
            resourceId: this._resource.id,
            propName: name,
            propValue: value
        });
    };
    ResourceApi.prototype.remove = function () {
        this._calendar.dispatch({
            type: 'REMOVE_RESOURCE',
            resourceId: this._resource.id
        });
    };
    ResourceApi.prototype.getParent = function () {
        var calendar = this._calendar;
        var parentId = this._resource.parentId;
        if (parentId) {
            return new ResourceApi(calendar, calendar.state.resourceSource[parentId]);
        }
        else {
            return null;
        }
    };
    ResourceApi.prototype.getChildren = function () {
        var thisResourceId = this._resource.id;
        var calendar = this._calendar;
        var resourceStore = calendar.state.resourceStore;
        var childApis = [];
        for (var resourceId in resourceStore) {
            if (resourceStore[resourceId].parentId === thisResourceId) {
                childApis.push(new ResourceApi(calendar, resourceStore[resourceId]));
            }
        }
        return childApis;
    };
    /*
    this is really inefficient!
    TODO: make EventApi::resourceIds a hash or keep an index in the Calendar's state
    */
    ResourceApi.prototype.getEvents = function () {
        var thisResourceId = this._resource.id;
        var calendar = this._calendar;
        var _a = calendar.state.eventStore, defs = _a.defs, instances = _a.instances;
        var eventApis = [];
        for (var instanceId in instances) {
            var instance = instances[instanceId];
            var def = defs[instance.defId];
            if (def.resourceIds.indexOf(thisResourceId) !== -1) { // inefficient!!!
                eventApis.push(new EventApi(calendar, def, instance));
            }
        }
        return eventApis;
    };
    Object.defineProperty(ResourceApi.prototype, "id", {
        get: function () { return this._resource.id; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "title", {
        get: function () { return this._resource.title; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventConstraint", {
        get: function () { return this._resource.ui.constraints[0] || null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventOverlap", {
        get: function () { return this._resource.ui.overlap; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventAllow", {
        get: function () { return this._resource.ui.allows[0] || null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventBackgroundColor", {
        get: function () { return this._resource.ui.backgroundColor; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventBorderColor", {
        get: function () { return this._resource.ui.borderColor; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventTextColor", {
        get: function () { return this._resource.ui.textColor; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "eventClassNames", {
        // NOTE: user can't modify these because Object.freeze was called in event-def parsing
        get: function () { return this._resource.ui.classNames; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResourceApi.prototype, "extendedProps", {
        get: function () { return this._resource.extendedProps; },
        enumerable: true,
        configurable: true
    });
    return ResourceApi;
}());
export default ResourceApi;
